import { Row, flexRender } from '@tanstack/react-table';
import React from 'react';

import { RowProps } from '../table/rows/TRow';

export interface RowElementProps<T extends object> extends RowProps {
    className?: string;
    row: Row<T>;
    onClick?: (element: T) => void;
    id: string;
}

export const RowElement = <T extends object>(props: RowElementProps<T>) => {
    return (
        <tr
            data-testid={`row-${props.row.index}`}
            id={props.row.id}
            key={props.row.id}
            onClick={() => props.onClick && props.onClick(props.row.original)}
            className={
                'group border-border-default border-b ' +
                (props.row.getIsExpanded() && props.row.getCanExpand() ? `bg-gray-${500 - props.row.depth * 100}` : ' ') +
                (props.className || (props.onClick ? 'hover:bg-background-default hover:cursor-pointer' : '')) +
                ((props.row.original as any)?.delete_timestamp ? ' bg-status-danger/50' : '')
            }>
            {props.row.getVisibleCells().map((cell) => flexRender(cell.column.columnDef.cell, cell.getContext()))}
        </tr>
    );
};
